import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Store } from '@ngxs/store';
import { CasesService } from 'app/shared/cases';
import { HotelService } from 'app/shared/hotel/hotel.service';
import { Log } from 'app/shared/logs/types';
import { SurveyAnswerService } from 'app/shared/surveys/survey-answer.service';
import { UtilService } from 'app/shared/util.service';
import { ChangeBase } from 'app/states/fidelity-desk/fidelity-desk.actions';
import { FidelityDeskState } from 'app/states/fidelity-desk/fidelity-desk.state';

@Component({
    selector: 'mh-logs-list',
    templateUrl: './logs-list.component.html',
    styleUrls: ['./logs-list.component.scss'],
    standalone: false
})
export class LogsListComponent implements OnInit {
  //fixed options
  PAGE_SIZE_OPTIONS = [10, 20, 50]

  @Input() logs: Log[]
  @Input() language:any;
  loading: boolean = false;

  pageEvent: PageEvent;

  commercialExecutivesList = [];
  base: any;
  reasons_discarded: any;
  deleteReasonsList: any;

  constructor(
    private hotelService: HotelService,
    private store: Store,
    public casesService: CasesService,
    private utilService: UtilService,
    private surveyAnswerService: SurveyAnswerService,
  ) {}

  async ngOnInit() {
    try {
      await this.retrieveBase();
      const hotelBase = await this.hotelService.getBase().toPromise();
      this.commercialExecutivesList = hotelBase['commercial_executives'];
    } catch {
      this.commercialExecutivesList = [];
    }
  }

  async retrieveBase() {
    this.base = this.store.selectSnapshot(FidelityDeskState.base);
    this.reasons_discarded = this.base?.reasons_discarded;
    this.deleteReasonsList = await this.surveyAnswerService.getDeleteReasonsList().toPromise();
    if ( this.base ) return;
    this.updateBase();
  }

  private updateBase() {
    this.loading = true;
    this.casesService.getBase().subscribe((response) => {
      this.store.dispatch(new ChangeBase(response));
      this.base = response;
      this.reasons_discarded = this.base?.reasons_discarded;
      this.loading = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.logs) this.refreshPageEvent();
  }

  handlePaginate = (event: PageEvent) => {
    this.pageEvent = event;
  }

  refreshPageEvent() {
    this.pageEvent = <PageEvent>{
      pageIndex: 0,
      pageSize: (this.pageEvent || {pageSize: 20}).pageSize,
      length: 0,
    }
  }


  get currentLangId() {
    return this.utilService.availableLanguages.find( lang => lang.code === this.language )?.id;
  }
}
